import { action } from 'typesafe-actions';
import { Types } from './types';
import { IShipToCustomerItem } from '../../../services/EntryOrder';
import { ICustomer } from '../customers/types';

export const loadReceiversFrom = (customer: ICustomer) =>
  action(Types.LOAD_RECEIVERS_FROM_CUSTOMER, customer);

export const loadReceiversForBP = (customerId: string) =>
  action(Types.LOAD_RECEIVERS, customerId);

export const loadReceiversForBPLoading = (customerId: string) =>
  action(Types.LOAD_RECEIVERS_LOADING, customerId);

export const loadReceiversForBPSuccess = (
  customerId: string,
  items: IShipToCustomerItem[]
) => action(Types.LOAD_RECEIVERS_SUCCESS, { customerId, items });
